<template>
	<Overlay class="overlay-speed" :data-for="dataFor" placement="below" @close="emit('close')">
		<div class="speed-options" role="group" :aria-label="t('SpeechSpeed')">
			<button v-for="speed in SPEED_STEPS" :key="speed" class="speed-option" type="button"
					:class="{ 'is-active': speed === modelValue }" :aria-pressed="speed === modelValue"
					@click="handlePick(speed)">
				{{ speed }}x
			</button>
		</div>
	</Overlay>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import Overlay from './Overlay.vue'

/**
 * 語速六個倍率，離散選項直接點比拖滑桿準
 */
const SPEED_STEPS = [0.75, 1, 1.25, 1.5, 1.75, 2]

/**
 * 語速面板：六個等寬按鈕，選完就關
 */
withDefaults(defineProps<{
	/**
	 * 錨點元素的 id，錨點在畫面上方所以往下開
	 */
	dataFor: string
	/**
	 * 目前語速（v-model）
	 */
	modelValue?: number
}>(), {
	modelValue: 1,
})

const emit = defineEmits<{
	'update:modelValue': [value: number]
	'close': []
}>()

/**
 * 取得 i18n
 */
const { t } = useI18n()

/**
 * 選了某個倍率：發出新值並關閉
 * @param speed {number}
 * @return {void}
 */
const handlePick = (speed: number): void => {
	// 發出新語速
	emit('update:modelValue', speed)
	// 選完就關
	emit('close')
}
</script>
<style lang="scss">
.speed-options {
	display: flex;
	gap: 4px;
	padding: 8px;
}

.speed-option {
	// 等寬：六顆平分，內容再長也不會有一顆特別胖
	flex: 1 1 0;
	min-width: 48px;
	height: 32px;
	padding: 0 4px;
	border: none;
	border-radius: 8px;
	background: none;
	color: var(--text-body-01);
	font-family: inherit;
	font-size: 14px;
	font-weight: 600;
	white-space: nowrap;
	cursor: pointer;

	&:hover {
		background: rgba(21, 21, 21, 0.06);
	}

	&.is-active {
		background: var(--ui-grey-darkest);
		color: #fff;
	}
}
</style>
